import axios from 'axios';
import Cookies from "js-cookie";

import unflatten from './unflatten.js';
import load_stats from './load_stats.js'
import { generateCharacter  } from '../../../helpers/randomCharacter.js';

import { BLANK_CHARACTER } from '../../../constants/characters';
import { charsheetAPI, TABLE_CHARS, DEFAULT_CAMPAIGN } from '../../../globals.js';
import { sanitizeCharName } from '../../../helpers/sanitizeInput.js';

var txt = ""

const charsheetTable = TABLE_CHARS

// SET THE CAMPAIGN NAME - ** not used, campaign taken from Cookie **
let campaign = DEFAULT_CAMPAIGN
if ( Cookies.get('currentCampaign') ) {
    campaign = Cookies.get('currentCampaign');
}

async function Get01 ( URL, Header = {} ) {
    const res = await axios.get( URL, Header );
    console.log({ RESULT: res });
    return res;
}

// PACKDATA: returns a CHARACTER_DATA_DYNAMO data dictionary, suitable for saving
function packData ( data ) {
    
        let newChar = {};
        newChar.name = data.name;
        const { name, ...dataWithoutName } = data;
        newChar.chardata = dataWithoutName;
        newChar.campaign = Cookies.get('currentCampaign');
        newChar.version = '0.4';
        return newChar;
}

/* -----------------------------------------------------------------------------------
   LOAD_CHAR

   Gets character data from API, based on name and userData.currentCampaign

   If successful, it returns the data that is stored in dynamoDB with that campaign+name

   ----------------------------------------------------------------------------------- */
async function LOAD_CHAR ( charname, setChar, ask=true, userData, caller='Other' ) {
  
  console.log('Called by:', caller);
  if (typeof caller !== 'string') return { data: packData(BLANK_CHARACTER), usedCache: false }


    if ( charname === 'blank' ) {
        console.log('LOAD_CHAR: blank character requested ', BLANK_CHARACTER );
        let blankChar = packData( BLANK_CHARACTER );
        
        return { data: blankChar, usedCache: false };
    }

    var loadfile = charname;

    // SET THE CAMPAIGN NAME
    const campaign = userData.currentCampaign || Cookies.get('currentCampaign');

    if (ask) {
        if (charname === undefined) {
            loadfile = prompt("Load file:", charname );
            // strip trailing spaces
            loadfile = loadfile.trim();

            if (loadfile === null || loadfile === "") {
                    txt = "User cancelled the prompt.";
                    console.log(txt);
                    return { data: 'User Cancelled', usedCache: false }; }
            else {  loadfile = loadfile + "" };  }

        else {
            loadfile = prompt("Load file:", charname );

            if (loadfile === null || loadfile === "") {
                txt = "User cancelled the prompt.";
                console.log(txt);
                return { data: 'User Cancelled', usedCache: false }; }
            else {  loadfile = loadfile + "" };
            // loadfile = charname;
        }

        loadfile = sanitizeCharName(loadfile);
        if (!loadfile) return { data: 'Invalid Name', usedCache: false };
    }

    // SHORTCUTS for our favorite characters

    if (loadfile === 'Yarg') { loadfile = 'Yarg Smashskull'; }
    if (loadfile === 'Lanora') { loadfile = 'Lanora Snugglebottom'; }
    if (loadfile === 'Gerald') { loadfile = 'Gerald the Bold'; }
    if (loadfile === 'Sylonnus') { loadfile = 'Sylonnus Transvexus'; }
    if (loadfile === 'Edward') { loadfile = 'Edward the Enforcer'; }
    
    console.log("LOAD_CHAR>> " + loadfile )

    if (loadfile === 'random' ) {
        console.log('LOAD_CHAR: random character requested');
        let randomCharStats = generateCharacter('random');
        let randomChar = packData( randomCharStats );
        return { data: randomChar, usedCache: false };
    }

    // IF THE DATA IS IN LOCAL STORAGE, USE IT
    const storedChar = localStorage.getItem('chardata-stored');
    if (storedChar) {
        const parsedStoredChar = JSON.parse(storedChar);
        console.log('LOAD_CHAR>> stored Char found', parsedStoredChar);
        localStorage.removeItem('chardata-stored');

        return { data: parsedStoredChar, usedCache: false };
        
    } else {
        console.log('LOAD_CHAR>> No stored character data found.');
    }

    // get character data from dynamoDB API

    console.log(charsheetAPI + '?TableName=' + charsheetTable + '&campaign=' + campaign + '&name=' + loadfile)
    let charDataFromAPI = await Get01( charsheetAPI + '?TableName=' + charsheetTable + '&campaign=' + campaign + '&name=' + loadfile );
    console.log("charDataFromAPI:", charDataFromAPI)

    // handle the results of the API call

    if ( charDataFromAPI.data !== "" ) { 
        
        // load successful, store the name as a cookie

        Cookies.set("currentChar", charDataFromAPI.data.name, { expires: 30 } );
        console.log('loadchar2 cookie set',charDataFromAPI.data.name);


    } else {
        // error with the data fetch
        if (loadfile === 'Sample Character') { // for Sample Character, go to Greyhawk20
            console.log('youve reached the sample character error')
            charDataFromAPI = await Get01( charsheetAPI + '?TableName=' + charsheetTable + '&campaign=' + DEFAULT_CAMPAIGN + '&name=' + loadfile );
            console.log("charDataFromAPI:", charDataFromAPI)
            if ( charDataFromAPI.data !== "" ) {
                Cookies.set("currentChar", charDataFromAPI.data.name, { expires: 30 } );
                console.log('loadchar2 cookie set',charDataFromAPI.data.name);
            }
        } else {
            // if char0data is found in local storage, use that
            if ( localStorage.getItem('char0data') ) {
                alert(`Character ${loadfile} not found in ${campaign}, using cache`)
                console.log('LOAD_CHAR: char0data found in local storage, using that');
                let char0data = JSON.parse(localStorage.getItem('char0data'));
                console.log('char0data:', char0data);
                return { data: char0data, usedCache: true };
            } else {
                alert(`Character ${loadfile} not found in ${campaign}`)
            }

        }
        console.log(charDataFromAPI.data)
        if ( !charDataFromAPI.data  ) {
            console.log('LOAD: name not found or no data returned');
            let blankChar = JSON.parse(JSON.stringify(BLANK_CHARACTER));
            blankChar.name = loadfile;
            return { data: packData( blankChar ), usedCache: false }
        }    
    }

    // the old way of doing this. works with Charsheet0 but not CharsheetFull
    // load_stats(charDataFromAPI.data, setChar );
    
    // return the character data
    
    if (charDataFromAPI.data) console.log('CHAR data received ', charDataFromAPI.data)

    return { data: charDataFromAPI.data, usedCache: false }


}

export default LOAD_CHAR